let appRoot = document.getElementById('app-root');

export default {
    schoolToken: appRoot.dataset['schoolToken'],
    clientId: process.env.REACT_APP_CLIENT_ID,
    apiUrl: process.env.REACT_APP_API_URL,
    authorizeNet: {
        apiLoginId: appRoot.dataset['authorizeNetApiLoginId'],
        clientKey: appRoot.dataset['authorizeNetClientKey'],
        environment: appRoot.dataset['authorizeNetEnvironment']
    }
};
